import React, { FunctionComponent } from 'react';
import cn from 'classnames';

export enum IconSize {
  xxs = 'xxs',
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  xxl = 'xxl',
}

const getSizeStyles = (variant: IconSize) => {
  switch (variant) {
    case IconSize.xxs:
      return 'w-1.5 h-1.5 min-w-[6px] min-h-[6px]';
    case IconSize.xs:
      return 'w-2 h-2 min-w-[8px] min-h-[8px]';
    case IconSize.sm:
      return 'w-2.5 h-2.5 min-w-[10px] min-h-[10px]';
    case IconSize.md:
      return 'w-3 h-3 min-w-[12px] min-h-[12px]';
    case IconSize.lg:
      return 'w-3.5 h-3.5 min-w-[14px] min-h-[14px]';
    case IconSize.xl:
      return 'w-4 h-4 min-w-[16px] min-h-[16px]';
    case IconSize.xxl:
      return 'w-5 h-5 min-w-[20px] min-h-[20px]';
    default:
      return 'w-3 h-3 min-w-[12px] min-h-[12px]';
  }
};

export interface IconWrapperProps {
  size?: IconSize;
  className?: string;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const IconWrapper: FunctionComponent<IconWrapperProps> = ({
  className = '',
  size = IconSize.md,
  icon,
  onClick,
  ...props
}) => {
  const IconComponent = icon || 'div';
  return (
    <div
      className={cn(getSizeStyles(size), className)}
      onClick={onClick}
      {...props}
    >
      <IconComponent className={'w-full h-full'} />
    </div>
  );
};
